<template>
  <ModalOverlay :is-visible="isVisible" @close="emit('close')">
    <CardBase class="info-container">
      <template #header>
        <div class="header">
          <TextBase :text="title ?? ''" type="h5" />
          <ButtonText
            id="info-overlay-exit"
            class="close-button"
            :iconLeft="iconXSmall"
            size="extra-small"
            @onClicked="emit('close')"
          />
        </div>
      </template>
      <MarkDown v-if="info" :source="info" />
    </CardBase>
  </ModalOverlay>
</template>

<script lang="ts" setup>
import ModalOverlay from '@/design-system/molecules/ModalOverlay.vue'
import MarkDown from '@/components/MarkDown.vue'
import CardBase from './CardBase.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'
import iconXSmall from '@/design-system/assets/icons/Icon-X-Small.svg'

const emit = defineEmits(['close'])
defineProps<{
  isVisible: boolean
  title?: string
  info?: string
}>()
</script>

<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/mixins.scss';

.info-container {
  @include font-mixins.desktop-regular-paragraph;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 600px;
  max-height: 80vh;
  min-width: 800px;
  min-height: 400px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.close-button {
  width: 24px;
  height: 24px;
}
</style>
